module.exports = __webpack_public_path__ + "static/media/play.6b85ce88.svg";